import { FC } from "react";
import { ReindexSearchCollection } from "./reindex-search-collection";
import { useLazyQuery } from "@apollo/client";
import {
  StaffReIndexSearchCollectionContainerCaseReIndexDocument,
  StaffReIndexSearchCollectionContainerEntityReIndexDocument,
  StaffReIndexSearchCollectionContainerUserReIndexDocument,
  StaffReIndexSearchCollectionContainerIdentityCaseReIndexDocument,
  StaffReIndexSearchCollectionContainerCredentialCaseReIndexDocument,
  StaffReIndexSearchCollectionContainerSendReportCaseReIndexDocument,
} from "../../../../generated";
import { message } from "antd";

interface ReindexSearchCollectionContainerProps {}

export const ReindexSearchCollectionContainer: FC<ReindexSearchCollectionContainerProps> = (_props) => {
  const [reindexUserCollection, { loading: reindexUserCollectionLoading }] = useLazyQuery(StaffReIndexSearchCollectionContainerUserReIndexDocument, {
    fetchPolicy: "network-only",
  });

  const [reindexCaseCollection, { loading: reindexCaseCollectionLoading }] = useLazyQuery(StaffReIndexSearchCollectionContainerCaseReIndexDocument, {
    fetchPolicy: "network-only",
  });

  const [reindexEntityCollection, { loading: reindexEntityCollectionLoading }] = useLazyQuery(
    StaffReIndexSearchCollectionContainerEntityReIndexDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  const [reindexIdCaseCollection, { loading: reindexIdCaseCollectionLoading }] = useLazyQuery(
    StaffReIndexSearchCollectionContainerIdentityCaseReIndexDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  const [reindexCredCaseCollection, { loading: reindexCredCaseCollectionLoading }] = useLazyQuery(
    StaffReIndexSearchCollectionContainerCredentialCaseReIndexDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  const [reindexSendReportCaseCollection, { loading: reindexSendReportCaseCollectionLoading }] = useLazyQuery(
    StaffReIndexSearchCollectionContainerSendReportCaseReIndexDocument,
    {
      fetchPolicy: "network-only",
    }
  );

  const handleReIndexUserCollection = () => {
    reindexUserCollection().then((data) => {
      if (data.data?.userReIndex?.applicantUserReIndexErrors?.length === 0 && data.data?.userReIndex?.staffUserReIndexErrors?.length === 0) {
        message.success("Re-indexing User collection is successful!");
      } else {
        message.success(
          "Re-indexing User collection finished, but some records from User collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index User errors:");
        console.log(data.data?.userReIndex);
      }
    });
  };

  const handleReIndexCaseCollection = () => {
    reindexCaseCollection().then((data) => {
      if (
        data.data?.caseReIndex?.identityCaseReIndexErrors?.length === 0 &&
        data.data?.caseReIndex?.credentialCaseReIndexErrors?.length === 0 &&
        data.data?.caseReIndex?.sendReportCaseReIndexErrors?.length === 0
      ) {
        message.success("Re-indexing Case collection is successful!");
      } else {
        message.success(
          "Re-indexing Case collection finished, but some records from Case collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index Case errors:");
        console.log(data.data?.caseReIndex);
      }
    });
  };

  const handleReIndexEntityCollection = () => {
    reindexEntityCollection().then((data) => {
      if (data.data?.entityReIndex?.entityReIndexErrors?.length === 0) {
        message.success("Re-indexing Entity collection is successful!");
      } else {
        message.success(
          "Re-indexing Entity collection finished, but some records from Entity collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index Entity errors:");
        console.log(data.data?.entityReIndex);
      }
    });
  };

  const handleReIndexIdCaseCollection = () => {
    reindexIdCaseCollection().then((data) => {
      if (data.data?.identityCaseReIndex) {
        message.success("Re-indexing ID Case collection is successful!");
      } else {
        message.success(
          "Re-indexing ID Case collection finished, but some records from ID Case collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index ID Case errors:");
        console.log(data.data?.identityCaseReIndex);
      }
    });
  };

  const handleReIndexCredCaseCollection = () => {
    reindexCredCaseCollection().then((data) => {
      if (data.data?.credentialCaseReIndex) {
        message.success("Re-indexing Credential Case collection is successful!");
      } else {
        message.success(
          "Re-indexing Cred Case collection finished, but some records from Cred Case collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index Credential Case errors:");
        console.log(data.data?.credentialCaseReIndex);
      }
    });
  };

  const handleReIndexSendReportCaseCollection = () => {
    reindexSendReportCaseCollection().then((data) => {
      if (data.data?.sendReportCaseReIndex) {
        message.success("Re-indexing Send Report Case collection is successful!");
      } else {
        message.success(
          "Re-indexing Send Report Case collection finished, but some records from Send Report Case collection failed to re-index. Please check the logs for more details"
        );
        console.log("Re-index Send Report Case errors:");
        console.log(data.data?.sendReportCaseReIndex);
      }
    });
  };

  return (
    <>
      <ReindexSearchCollection
        handleReIndexUserCollection={handleReIndexUserCollection}
        reindexUserCollectionLoading={reindexUserCollectionLoading}
        handleReIndexCaseCollection={handleReIndexCaseCollection}
        reindexCaseCollectionLoading={reindexCaseCollectionLoading}
        handleReIndexEntityCollection={handleReIndexEntityCollection}
        reindexEntityCollectionLoading={reindexEntityCollectionLoading}
        handleReIndexIdCaseCollection={handleReIndexIdCaseCollection}
        reindexIdCaseCollectionLoading={reindexIdCaseCollectionLoading}
        handleReIndexCredCaseCollection={handleReIndexCredCaseCollection}
        reindexCredCaseCollectionLoading={reindexCredCaseCollectionLoading}
        handleReIndexSendReportCaseCollection={handleReIndexSendReportCaseCollection}
        reindexSendReportCaseCollectionLoading={reindexSendReportCaseCollectionLoading}
      />
    </>
  );
};
